export enum ExceptionType {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}